import React from "react";
import {Nav, NavLink as RsNavLink} from "reactstrap";
import nav from "./_nav";

export const submenu = (items, navList, backToMainMenu) => {

  const onClickBackToMainMenu = () => {
    backToMainMenu()
  }

  return (
    <div>
      <div onClick={() => onClickBackToMainMenu()} className={"backToMenu-button"}>
        <img src={"img/arrow-left.svg"} />
        <span>Retour</span>
      </div>

      <div className={"nav-link"}>
        {items.icon &&
           <i className={items.icon}></i>
        }
        {items.name}
      </div>

      <nav className="submenu-sidebar">
        <Nav>{ navList(items.children)}</Nav>
      </nav>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/submenu.js